var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DropdownNationalHubsLayout',{attrs:{"links":_vm.transformedLinks,"max-column-items":4,"single-link":{
      title: 'See all salaries',
      url: '/salaries',
    },"drop-down-title":"Most Popular Salaries"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }